import { useEffect } from 'react';
import { AppRouter } from './router';
import { AppProvider } from './providers/provider';
import { attachAuthInterceptor } from '~shared/api/api.instance';
import { store } from '~shared/store';
import { initializeFocusDetection } from '~shared/lib/accessibility/focus-detection';

attachAuthInterceptor(() => store.getState().session?.sessionId);

export const App = () => {
  // Initialize focus detection on mount
  useEffect(() => {
    const cleanup = initializeFocusDetection();
    return cleanup;
  }, []);

  return (
    <AppProvider>
      <AppRouter />
    </AppProvider>
  );
};
